import React from 'react';

/**
 * Top-of-page stats strip — 4 cards showing the headline live numbers.
 */
const LiveStatsHeader = ({ stats }) => {
  const items = [
    {
      label: 'Active Now',
      value: stats?.joined ?? 0,
      tone: 'text-emerald-600',
      sub: 'Currently joined',
    },
    {
      label: 'Left',
      value: stats?.left ?? 0,
      tone: 'text-red-600',
      sub: stats?.left > 0 ? 'Disconnected' : 'No leaves',
    },
    {
      label: 'Engagement',
      value: `${stats?.avgEngagement ?? 0}%`,
      tone: 'text-blue-600',
      sub: 'Avg across active',
    },
    {
      label: 'Activities',
      value: `${stats?.completedActivities ?? 0}/${stats?.totalActivities ?? 0}`,
      tone: 'text-neutral-900',
      sub: 'Completed / total',
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      {items.map((it) => (
        <div key={it.label} className="bg-white rounded-2xl border border-neutral-100 p-4">
          <p className="text-xs font-medium text-neutral-500 uppercase tracking-wide">{it.label}</p>
          <p className={`text-2xl sm:text-3xl font-bold mt-1 ${it.tone}`}>{it.value}</p>
          <p className="text-xs text-neutral-400 mt-1">{it.sub}</p>
        </div>
      ))}
    </div>
  );
};

export default LiveStatsHeader;
